import { withRouter, Redirect } from 'react-router-dom'
import React from 'react'
import Popup from 'react-popup'
import intl from 'react-intl-universal'
import { connect } from 'react-redux'
import { getOrder, finishOrder, selectOrder, releaseOrder } from '../actions/PackActions'
import { selectShipping } from '../actions/ShippingActions'
import ProgressBar from './ProgressBar'
import ProductListItem from './ProductListItem'
import { b64EncodeUnicode } from '../utils/Tools'
import { ReactComponent as Check } from '../assets/check.svg'
require('./ShippingList')
require('./MaterialsList')

function getProductListItem(product, parent, group_treshold) {
  let supercount = product.product_uom_qty >= group_treshold
  let k = 1
  if (supercount){
    k++
    return (<ProductListItem
             key={product.line_id+'.'+product.product_id+'.'+k}
             product={product}
             qty={product.product_uom_qty}
             supercount={supercount}
             parent={parent}/>
    )
  } else {
    let arr = []
    for (var i = 0; i < product.product_uom_qty; i++) {
      k++
      arr.push(<ProductListItem
                key={product.line_id+'.'+product.product_id+'.'+k}
                product={product}
                qty={(product.product_uom_qty - i) < 1 ? Math.round((product.product_uom_qty - i)*100)/100 : 1}
                supercount={supercount}
                parent={parent}/>
      )
    }
    return arr
  }

}

const inpost_size_options = [
  ['A','A'],
  ['B','B'],
  ['C','C'],
]

const orlen_size_options = [
  ['S','S'],
  ['M','M'],
  ['L','L'],
  ['Mini','MINI'],
]

const mapStateToProps = state => ({
  authenticated: state.auth.session.id !== false,
  product_confirmation_method: state.config.product_confirmation_method,
  auto_select_first: state.config.auto_select_first,
  verify_qty: !!state.config.verify_qty,
  confirm_note: state.config.confirm_note,
  show_company: state.config.show_company,
  carrier_selection: state.config.carrier_selection,
  inventory_manage_materials: state.config.inventory_manage_materials,
  material_products: state.config.material_products,
  inpost_dostawy: state.config.inpost_dostawy || [],
  orlen_dostawy: state.config.orlen_dostawy || [],
  add_package: state.config.add_package,
  add_delivery: state.config.add_delivery,
  group_treshold: state.config.group_treshold,
  pack: state.router.location.query.pack ? parseInt(state.router.location.query.pack) : false,
  order_id: state.router.location.query.order ? parseInt(state.router.location.query.order) : false,
  order: state.pack.order,
  processing: state.pack.processing,
  last_scanned: state.pack.last_scanned,
  shipping: state.shipping.shipping
})

const mapDispatchToProps = dispatch => ({
  getOrderAction: (code, id) => dispatch(getOrder(code, id)),
  finishOrderAction: (data) => dispatch(finishOrder(data)),
  selectOrderAction: () => dispatch(selectOrder()),
  selectShippingAction: (id) => dispatch(selectShipping(id)),
  releaseOrderAction: (order_id) => dispatch(releaseOrder(order_id)),
})

class OrderComponent extends React.Component {
  constructor() {
    super()
    this.state = {
      code: '',
      progress: 0,
      valid: false
    }
  }

  componentDidMount() {
    const { getOrderAction, authenticated, order_id, order, product_confirmation_method, last_scanned, auto_select_first } = this.props
    if(authenticated && !order) getOrderAction(false, order_id)
    if(auto_select_first && order && last_scanned){
      let checkbox = document.querySelector('.produkt[data-barcode="'+CSS.escape(last_scanned)+'"] .checkbox.mainCheckbox:not(.checked), '+
                                            '.produkt .bundleItemList tr[data-barcode="'+CSS.escape(last_scanned)+'"] .checkbox:not(.checked), '+
                                            '.produkt[data-name="'+b64EncodeUnicode(last_scanned)+'"] .checkbox.mainCheckbox:not(.checked), '+
                                            '.produkt .bundleItemList tr[data-name="'+b64EncodeUnicode(last_scanned)+'"] .checkbox:not(.checked), '+
                                            '.produkt[data-code="'+CSS.escape(last_scanned)+'"] .checkbox.mainCheckbox:not(.checked), '+
                                            '.produkt .bundleItemList tr[data-code="'+CSS.escape(last_scanned)+'"] .checkbox:not(.checked)'
                                           )
      if(!checkbox){
        let code = document.querySelector('.produkt .default_code[data-code="'+CSS.escape(last_scanned)+'"]')
        if(code){
          code.closest('.produkt.ramka')
          checkbox = code.closest('.produkt.ramka').querySelector('.checkbox:not(.checked)')
        }
      }
      if(checkbox){
        let parent = checkbox.closest('.produkt.ramka')
        this.toggleCheckbox(checkbox, parent)
      }
    }
  }

  componentDidUpdate(){
    const { product_confirmation_method, shipping } = this.props
    if(['scan', 'scan_click'].includes(product_confirmation_method) && shipping === false){
      document.getElementById('scanner').focus()
    }
  }

  deselectOrder = (event) => {
    const {selectOrderAction, releaseOrderAction, order_id} = this.props
    releaseOrderAction(order_id)
    selectOrderAction()
  }

  doToggleCheckbox = (checkbox, parent) => {
    checkbox.classList.toggle('checked')

    document.querySelectorAll('.produkt').forEach(el => el.classList.remove('last_scanned'))
    checkbox.closest('[data-barcode]').classList.add('last_scanned')

    if(parent.querySelector('.bundleItemList')){
      if(checkbox.classList.contains('mainCheckbox')){
        document.querySelectorAll('.bundleItemList .checkbox').forEach(el => el.classList.toggle('checked', checkbox.classList.contains('checked')))
      } else {
        parent.querySelector('.product_checkbox .checkbox').classList.toggle('checked', !parent.querySelector('.bundleItemList .checkbox:not(.checked)'))
      }
    }

    this.toggleConfirmButton()
  }

  toggleCheckbox = (checkbox, parent) => {
    var cnt = parent.getAttribute('data-prods')
    let bundle_cnt = 0
    if(checkbox.classList.contains('multiproduct')){
      bundle_cnt = checkbox.closest('tr').getAttribute('data-qty')
      cnt = cnt+' x '+bundle_cnt
    }
    const {verify_qty, group_treshold} = this.props
    if(!verify_qty || (!parent.classList.contains('supercount') && !(bundle_cnt >= group_treshold)) ||
       checkbox.classList.contains('checked')
      ){
        this.doToggleCheckbox(checkbox, parent)
    } else{
      let self = this
      Popup.create({
        content: intl.get('Czy na pewno spakowałeś X pozycji tego SKU?', {cnt: cnt}),
        buttons: {
          right: [{
            text: intl.get('Tak'),
            key: 'enter',
            action: function () {
              Popup.close()
              self.doToggleCheckbox(checkbox, parent)
            }
          },
          {
            text: intl.get('Nie'),
            className: 'cancel-button',
            action: function () {
              Popup.close()
            }
          }]
        }
      })
    }
  }

  handleScanner = (event) => {
    if (event.which === 13) {
      let ean = event.target.value
      let checkbox = document.querySelector('.produkt[data-barcode="'+ean+'"] .checkbox.mainCheckbox:not(.checked), .produkt .bundleItemList tr[data-barcode="'+ean+'"] .checkbox:not(.checked)')
      if(!checkbox){
        if(event.target.id === 'scanner'){
          Popup.create({
            content: intl.get('Nie znaleziono produktu z tym kodem.'),
            buttons: {
              right: [{text: 'OK',
                      className: 'ok',
                      key: 'enter',
                      action: function () {
                        Popup.close()
                        document.getElementById('scanner').value = ''
                        document.getElementById('scanner').focus()
                      }}]
            }
          })
        }
      } else {
        var parent = checkbox.closest('.produkt.ramka')
        this.toggleCheckbox(checkbox, parent)
        event.target.value = ''
      }
      event.preventDefault()
      event.stopPropagation()
      return false
    }
  }

  sizePopup = (data, field_name, options) => {
    const self = this
    let buttons = options.map(opt => ({
      text: opt[0],
      action: function () {
        Popup.close()
        data[field_name] = opt[1]
        self.handleFinishOrder(data)
      }
    }))
    buttons.push({
      text: intl.get('Anuluj'),
      className: 'cancel-button',
      action: function () {
        Popup.close()
      }
    })
    Popup.create({
      content: intl.get('Wybierz gabaryt paczki'),
      buttons: {
        right: buttons
      }
    })
  }

  handleFinishOrder(data){
    const { finishOrderAction, inventory_manage_materials, material_products } = this.props
    if (inventory_manage_materials && material_products.length){
      Popup.plugins().materials(data, this)
      return
    }
    finishOrderAction(data)
  }

  handleSubmit = (event) => {
    event.preventDefault()

    const { order, inpost_dostawy, orlen_dostawy } = this.props
    let data = {}

    document.querySelectorAll('input').forEach(input => {
      if(input.type === 'radio' && !input.checked){ return }
      let val = input.value
      if ((val !== '') && !isNaN(val)){ val = parseInt(val) }
      if(input.type === 'checkbox'){
    	   val = input.checked
      }
      data[input.name] = val
    })

    if((data['carrier_id'] || order.carrier_id) &&
       inpost_dostawy.includes(data['carrier_id'] || order.carrier_id) &&
       order.shipping_order_ids.some((el) => {
         return (typeof el.date === 'undefined' || !el.date) &&
                !el.shipping_parcels_ids.some((parcel) => {
                  return parcel.size
                })
       })
     ){
       this.sizePopup(data, 'inpost_size', inpost_size_options)
    } else if((data['carrier_id'] || order.carrier_id) &&
       orlen_dostawy.includes(data['carrier_id'] || order.carrier_id) &&
       order.shipping_order_ids.some((el) => {
         return (typeof el.date === 'undefined' || !el.date) &&
                !el.shipping_parcels_ids.some((parcel) => {
                  return parcel.size
                })
       })
     ){
       this.sizePopup(data, 'orlen_size', orlen_size_options)
    } else {
      this.handleFinishOrder(data)
    }
  }

  toggleConfirmButton = () => {
    let state = {}
    const {progress, valid} = this.state
    if(!document.querySelector('.produkt .mainCheckbox:not(.checked), .mainCheckbox.uwagiCheckbox:not(.checked)')
       && !document.querySelector('.produkt .productVariantValue.proper:not(.selected)')){
      state.valid = true
    } else {
      state.valid = false
    }
    //Progress
    let all = document.querySelectorAll('.produkt .mainCheckbox, .mainCheckbox.uwagiCheckbox').length
    let checked = 0
    if(document.querySelector('.mainCheckbox.uwagiCheckbox.checked')){
      checked += 1
    }
    document.querySelectorAll('.produkt .mainCheckbox.checked').forEach((item) => {
      if (!item.querySelector('.productVariantValue.proper:not(.selected)')){
        checked += 1
      }
    })
    state.progress = checked / all * 100
    if(all === 0){
      state.progress = 100
      state.valid = true
    }
    if(state.progress !== progress || state.valid !== valid){
      this.setState(state)
    }
  }

  showShipping = (id) => {
    const { selectShippingAction } = this.props
    selectShippingAction(id)
  }

  newShipping = () => {
    const { selectShippingAction } = this.props
    selectShippingAction(0)
    return
  }

  shippingList = () => {
    const { shipping_order_ids } = this.props.order
    Popup.plugins().shipping(shipping_order_ids, this.newShipping, this)
  }

  noteCheckboxClick = (event) => {
    let $checkbox = event.currentTarget
    if ($checkbox.tagName === 'DIV'){
      $checkbox = $checkbox.parentElement.querySelector('.uwagiCheckbox')
    }
    $checkbox.classList.toggle('checked')
    this.toggleConfirmButton()
  }

  render() {
    const { authenticated } = this.props
    if(!authenticated) return (<Redirect to='/login' />)
    const odoo = window.ODOO.url + (window.ODOO.port?':'+window.ODOO.port:'')
    const {
      order,
      pack,
      product_confirmation_method,
      show_company,
      confirm_note,
      carrier_selection,
      group_treshold,
      add_delivery,
      add_package,
      processing
    } = this.props
    const { progress, valid } = this.state
    return (
      <>
      <ProgressBar percent={progress}/>
      <div className="pakowanie">
        <style dangerouslySetInnerHTML={{__html: `
          #app header, #app footer{ display: none }
          #app{ display: block }
        `}} />
        <div>
          <div className="pakowanie_header">
            <button className="pull-left secondary" onClick={this.deselectOrder}>{intl.get('Wstecz')}</button>
            { ['scan', 'scan_click'].includes(product_confirmation_method) &&
              <div className="scanner_wrapper">
                <input id="scanner"
                       type="text"
                       name="scanner"
                       placeholder={intl.get('Wprowadź kod produktu')}
                       onKeyPress={this.handleScanner}
                       autoComplete="off"/>
              </div>
            }
            <button onClick={this.handleSubmit} className="pull-right" id="zatwierdz" disabled={!valid || processing} >{intl.get('Dalej')}</button>
          </div>
          {order &&
            <div className="pakowanie_content row">
              <input type="hidden" name="order_id" value={order.id}/>
              <input type="hidden" name="paczka" value={pack}/>
              <div className="col-lg-5">
                <div className="pakowanie_order ramka">
                  <h4>
                    {intl.get('Zamówienie')} {order.name}
                  </h4>
                  <div className="order_data">
                    <div className="notes f_group">
                      <label>{intl.get('Uwagi klienta')}:</label>
                      <div>
                        {confirm_note && order.note &&
                            <div className="checkbox mainCheckbox uwagiCheckbox" onClick={this.noteCheckboxClick}>
                              <Check className="check"/>
                            </div>
                        }
                        <div className="note_text" onClick={this.noteCheckboxClick}>{order.note}</div>
                      </div>
                    </div>
                    <div className="carrier f_group">
                      <label>{intl.get('Metoda dostawy')}:</label>
                      {carrier_selection && order.carriers &&
                        <div className="carriers_radios">
                          {order.carriers.map(carrier => {
                            return(<div className="carrier_radio" key={carrier.id}>
                              <div className="carrier_thumbnail" style={{color: '#ccc', backgroundImage: `url("${odoo}/ideaerp_shipment_${order.carrier_comp}/static/img/logo.png")`}}/>
                              <input type="radio"
                                     name="carrier_id"
                                     id={'carrier_'+carrier.id}
                                     value={carrier.id}
                                     defaultChecked={order.carrier_id === carrier.id ? 'checked':''}/>
                              <label className={order.carrier_id === carrier.id ? 'initial':''}
                                     htmlFor={'carrier_'+carrier.id}
                                     onClick={this.confirmCarrierChange} data-value={carrier.id}>{carrier.name}</label>
                            </div>)
                          })}
                        </div>
                      }
                      <div>
                        {order.carrier_name}
                        <div>
                          <input type="hidden" name="carrier_id" value={order.carrier_id || ''}/>
                          {order.carrier_comp &&
                            <span className="shippinglogo">
                                <img src={`${odoo}/ideaerp_shipment_${order.carrier_comp}/static/img/logo.png`} alt="carrier"/><br/>
                            </span>
                          }
                        </div>
                      </div>
                      {(add_package || add_delivery) &&
                        <div className="add_package_wrapper">
                          {add_delivery &&
                            <button id="add_delivery" onClick={this.addDelivery}>{intl.get('Dodaj przesyłkę')}</button>
                          }
                          {add_package &&
                            <button id="add_package" onClick={this.addPackage}>{intl.get('Dodaj paczkę')}</button>
                          }
                        </div>
                      }
                    </div>
                    {show_company &&
                      <div className="date_order f_group">
                        <label>{intl.get('Firma')}:</label>
                        <div>{order.company}</div>
                      </div>
                    }
                    <div className="date_order f_group">
                      <label>{intl.get('Data zamówienia')}:</label>
                      <div>{order.date_order}</div>
                    </div>
                    <div className="amount_total f_group">
                      <label>{intl.get('Kwota zamówienia')}:</label>
                      <div>{order.amount_total}</div>
                    </div>
                    {order.integration_login &&
                    <div className="integration_login f_group">
                      <label>{intl.get('Login klienta')}:</label>
                      <div>{order.integration_login}</div>
                    </div>
                    }
                    {order.allegro_account &&
                      <div className="allegro_account f_group">
                        <label>{intl.get('Login Allegro sprzedawcy')}:</label>
                        <div>{order.allegro_account}</div>
                      </div>
                    }
                    <div className="delivery f_group">
                      <label>{intl.get('Adres dostawy')}:</label>
                      <div>
                        <div>{order.delivery_name}</div>
                        <div>{order.delivery_street}</div>
                        <div>{order.delivery_zip} {order.delivery_city}</div>
                      </div>
                    </div>
                    <div className="invoice f_group">
                      <label>{intl.get('Potwierdzenie')}:</label>
                      <div>{order.invoice_option ? intl.get('faktura') : intl.get('paragon')}</div>
                    </div>
                    {order.warehouseman &&
                    <div className="warehouseman f_group">
                      <label>{intl.get('Osoba zbierająca')}:</label>
                      <div>{order.warehouseman}</div>
                    </div>
                    }
                  </div>
                  <div className="text-center">
                    <button onClick={this.shippingList}>{intl.get('Przesyłki')}</button>
                  </div>
                </div>
              </div>
              <div className={'pakowanie_products col-lg-7'+(order.products.length>3?' many_products':'')}>
                {order.products.map(product => getProductListItem(product, this, (group_treshold || 10)))}
              </div>
            </div>
          }
        </div>
      </div>
      </>
    )
  }
}
const Order = connect(mapStateToProps, mapDispatchToProps)(OrderComponent)
export default withRouter(Order)
